import { render } from "./DocumentRequest.vue?vue&type=template&id=31420eef&bindings={\"items\":\"setup\",\"items_s\":\"setup\",\"items_reco\":\"setup\",\"detail\":\"setup\",\"setDetailPageID\":\"setup\",\"setDetailPageID_s\":\"setup\",\"state\":\"setup\"}"
import script from "./DocumentRequest.vue?vue&type=script&lang=ts"
export * from "./DocumentRequest.vue?vue&type=script&lang=ts"
script.render = render

export default script